import { useGetDashboardRevenueShareAccountsCountQuery } from 'src/api';

import { useDashboardCVAdminData } from './useDashboardCVAdminData';

export const useOverviewRevenueShareAccounts = () => {
  const { date } = useDashboardCVAdminData();

  const { data, loading } = useGetDashboardRevenueShareAccountsCountQuery({
    variables: {
      asOfDate: date.toISODate(),
    },
  });

  return {
    revenueShareAccounts: data?.getDashboardRevenueShareAccountsCount || 0,
    revenueShareAccountsLoading: loading,
  };
};
